import { render } from "./Abschliessen.vue?vue&type=template&id=4caa1846"
import script from "./Abschliessen.vue?vue&type=script&lang=js"
export * from "./Abschliessen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__